import { Spinner } from 'react-bootstrap';

export default function LoaderComponent({
  showloader = false,
  animation = 'border',
  size = 'md',
}) {
  return (
    <>
      {showloader && (
        <>
          <div className={'spinner-wrapper'}>
            <Spinner animation={animation} role="status" size={size}>
              <span className="visually-hidden">{'Loading...'}</span>
            </Spinner>
          </div>
        </>
      )}
    </>
  );
}
